/* ═══════════════════════════════════════════════════════════════
   THE BLOODY HUNDREDTH - Scroll Engine
   State machine driving map animations, route drawing, counters,
   aircraft loss sequences, and the running tally bar.

   Migrated to TAC Design System with IntersectionObserver fallback.
   ═══════════════════════════════════════════════════════════════ */

(function() {
  'use strict';

  /* ─── CONFIGURATION ─── */
  var CONFIG = {
    revealThreshold: 0.15,
    chapterThreshold: 0.3,
    counterDuration: 1500,
    routeDrawDuration: 2000,
    lossStagger: 200,
    tallyAnimDuration: 800,
    reducedMotion: false
  };

  /* ─── CHAPTER DATA ─── */
  /* Cumulative totals at each chapter point for the running tally */
  var CHAPTER_DATA = {
    'hero':  { missions: 0,   sorties: 0,    aircraft: 0,   kia: 0,   pow: 0 },
    '1':     { missions: 0,   sorties: 0,    aircraft: 0,   kia: 0,   pow: 0 },
    '2':     { missions: 0,   sorties: 0,    aircraft: 0,   kia: 0,   pow: 0 },
    '3':     { missions: 1,   sorties: 13,   aircraft: 3,   kia: 30,  pow: 0 },
    '4':     { missions: 9,   sorties: 180,  aircraft: 15,  kia: 120, pow: 30 },
    '5':     { missions: 22,  sorties: 380,  aircraft: 42,  kia: 270, pow: 150 },
    '6':     { missions: 45,  sorties: 800,  aircraft: 55,  kia: 320, pow: 200 },
    '7':     { missions: 120, sorties: 2800, aircraft: 95,  kia: 450, pow: 420 },
    '8':     { missions: 240, sorties: 6200, aircraft: 145, kia: 600, pow: 720 },
    '9':     { missions: 306, sorties: 8630, aircraft: 177, kia: 757, pow: 923 }
  };

  /* City coordinates on the SVG (matching bh-map-europe.liquid) */
  var CITY_COORDS = {
    'thorpe-abbotts': { x: 262, y: 248 },
    'london':         { x: 245, y: 278 },
    'bremen':         { x: 370, y: 225 },
    'munster':        { x: 358, y: 242 },
    'hamburg':        { x: 388, y: 215 },
    'berlin':         { x: 445, y: 235 },
    'schweinfurt':    { x: 400, y: 295 },
    'regensburg':     { x: 428, y: 318 },
    'merseburg':      { x: 430, y: 260 },
    'marienburg':     { x: 510, y: 225 },
    'normandy':       { x: 228, y: 298 },
    'trondheim':      { x: 365, y: 85 },
    'north-africa':   { x: 360, y: 530 },
    'ruhland':        { x: 452, y: 255 },
    'kearney':        { x: 30,  y: 260 }
  };

  /* ─── HELPERS: Use TAC selectors when available ─── */
  var $ = (window.TAC && TAC.$) ? TAC.$ : function(sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = (window.TAC && TAC.$$) ? TAC.$$ : function(sel, ctx) { return (ctx || document).querySelectorAll(sel); };

  /* ─── STATE ─── */
  var state = {
    currentChapter: null,
    activeRoutes: new Set(),
    activeCities: new Set(),
    tallyValues: { missions: 0, sorties: 0, aircraft: 0, kia: 0, pow: 0 },
    tallyVisible: false,
    initialized: false,
    lossAnimations: new Map(),
    routeLengths: new Map(),
    pendingTimeouts: []
  };

  /** Track a setTimeout so it can be cleared on destroy */
  function trackedTimeout(fn, delay) {
    var id = setTimeout(function() {
      /* Remove from tracking array after firing */
      var idx = state.pendingTimeouts.indexOf(id);
      if (idx !== -1) state.pendingTimeouts.splice(idx, 1);
      fn();
    }, delay);
    state.pendingTimeouts.push(id);
    return id;
  }

  /** Clear all pending timeouts */
  function clearPendingTimeouts() {
    for (var i = 0; i < state.pendingTimeouts.length; i++) {
      clearTimeout(state.pendingTimeouts[i]);
    }
    state.pendingTimeouts = [];
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* SVG ROUTE PATH MEASUREMENT                                  */
  /* ═══════════════════════════════════════════════════════════ */

  function measureRoutes() {
    var mapWrap = document.getElementById('bh-map-wrap');
    if (!mapWrap) return;

    var routes = $$('.bh-map__route', mapWrap);
    routes.forEach(function(route) {
      try {
        var length = route.getTotalLength();
        state.routeLengths.set(route.id, length);
        route.style.setProperty('--route-length', length);
        route.style.strokeDasharray = length;
        route.style.strokeDashoffset = length;
      } catch(e) {
        route.style.setProperty('--route-length', 1000);
      }
    });
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* LOSS ICON ROW BUILDER                                       */
  /* ═══════════════════════════════════════════════════════════ */

  function buildLossRows() {
    var rows = $$('.bh-loss-row[data-bh-loss]');

    rows.forEach(function(row) {
      var total = Math.min(parseInt(row.dataset.bhTotal, 10) || 13, 100);
      var losses = Math.min(parseInt(row.dataset.bhLoss, 10) || 0, total);

      row.innerHTML = '';
      var frag = document.createDocumentFragment();

      for (var i = 0; i < total; i++) {
        var icon = document.createElement('div');
        icon.className = 'bh-loss-icon';
        icon.dataset.index = i;
        if (i < total - losses) {
          icon.classList.add('bh-loss-icon--active');
        }
        icon.innerHTML =
          '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M12 2 L14 8 L22 10 L22 12 L14 11 L14 18 L17 20 L17 22 L12 20 L7 22 L7 20 L10 18 L10 11 L2 12 L2 10 L10 8 Z"/>' +
          '</svg>';
        frag.appendChild(icon);
      }
      row.appendChild(frag);
    });
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* SCROLL REVEAL - TAC.reveal() with fallback                  */
  /* ═══════════════════════════════════════════════════════════ */

  function setupRevealObserver(section) {
    var revealElements = $$('[data-bh-reveal], [data-bh-stagger]', section);
    if (!revealElements.length) return null;

    if (window.TAC && TAC.reveal) {
      /* Use TAC pooled observer - adds .is-visible on intersect */
      var cleanups = [];
      revealElements.forEach(function(el) {
        var unsub = TAC.observe(el, function(entry) {
          if (entry.isIntersecting) {
            el.classList.add('is-visible');
            el.classList.add('bh-visible');
          }
        }, { threshold: CONFIG.revealThreshold, rootMargin: '0px 0px -50px 0px' });
        cleanups.push(unsub);
      });
      return function() { cleanups.forEach(function(fn) { fn(); }); };
    }

    /* Fallback: native IntersectionObserver */
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          entry.target.classList.add('bh-visible');
        }
      });
    }, {
      threshold: CONFIG.revealThreshold,
      rootMargin: '0px 0px -50px 0px'
    });

    revealElements.forEach(function(el) { observer.observe(el); });
    return function() { observer.disconnect(); };
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* CHAPTER OBSERVER - drives map, tally, and state changes     */
  /* ═══════════════════════════════════════════════════════════ */

  function setupChapterObserver(section) {
    var chapters = $$('[data-bh-chapter]', section);
    if (!chapters.length) return null;

    if (window.TAC && TAC.observe) {
      var cleanups = [];
      chapters.forEach(function(ch) {
        var unsub = TAC.observe(ch, function(entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.1) {
            var chapterId = ch.dataset.bhChapter;
            if (chapterId !== state.currentChapter) {
              onChapterChange(chapterId, ch);
            }
          }
        }, {
          threshold: [0.1, 0.2, 0.3, 0.5, 0.7],
          rootMargin: '-10% 0px -10% 0px'
        });
        cleanups.push(unsub);
      });
      return function() { cleanups.forEach(function(fn) { fn(); }); };
    }

    /* Fallback: native IntersectionObserver */
    var observer = new IntersectionObserver(function(entries) {
      var mostVisible = null;
      var maxRatio = 0;

      entries.forEach(function(entry) {
        if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
          maxRatio = entry.intersectionRatio;
          mostVisible = entry.target;
        }
      });

      if (mostVisible) {
        var chapterId = mostVisible.dataset.bhChapter;
        if (chapterId !== state.currentChapter) {
          onChapterChange(chapterId, mostVisible);
        }
      }
    }, {
      threshold: [0.1, 0.2, 0.3, 0.5, 0.7],
      rootMargin: '-10% 0px -10% 0px'
    });

    chapters.forEach(function(ch) { observer.observe(ch); });
    return function() { observer.disconnect(); };
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* CHAPTER CHANGE HANDLER                                      */
  /* ═══════════════════════════════════════════════════════════ */

  function onChapterChange(chapterId, element) {
    state.currentChapter = chapterId;

    /* 1. Update tally bar visibility */
    updateTallyVisibility(chapterId);

    /* 2. Animate tally counters */
    if (CHAPTER_DATA[chapterId]) {
      animateTally(CHAPTER_DATA[chapterId]);
    }

    /* 3. Update map routes */
    updateMapRoutes(element);

    /* 4. Update city highlights */
    updateCityHighlights(element);

    /* 5. Trigger loss animations for this chapter */
    triggerLossAnimations(element);

    /* 6. Activate map */
    activateMap(chapterId !== 'hero');

    /* 7. Fire flak effects if applicable */
    if (['3', '4', '5', '7', '8'].indexOf(chapterId) !== -1) {
      scheduleFlakBursts(element);
    }

    /* 8. Update chapter progress indicator */
    updateProgressIndicator(chapterId);
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* TALLY BAR                                                   */
  /* ═══════════════════════════════════════════════════════════ */

  function updateTallyVisibility(chapterId) {
    var tally = document.getElementById('bh-tally');
    if (!tally) return;

    var shouldShow = chapterId !== 'hero' && chapterId !== '1';

    if (shouldShow && !state.tallyVisible) {
      tally.classList.add('bh-tally--visible');
      state.tallyVisible = true;
    } else if (!shouldShow && state.tallyVisible) {
      tally.classList.remove('bh-tally--visible');
      state.tallyVisible = false;
    }
  }

  function animateTally(targetValues) {
    var fields = ['missions', 'sorties', 'aircraft', 'kia', 'pow'];

    fields.forEach(function(field) {
      var el = $('[data-bh-tally="' + field + '"]');
      if (!el) return;

      var startVal = state.tallyValues[field];
      var endVal = targetValues[field];

      if (startVal === endVal) return;

      if (CONFIG.reducedMotion) {
        el.textContent = formatNumber(endVal);
        state.tallyValues[field] = endVal;
        return;
      }

      animateCounter(el, startVal, endVal, CONFIG.tallyAnimDuration, function(val) {
        state.tallyValues[field] = val;
      });
    });
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* COUNTER ANIMATION                                           */
  /* ═══════════════════════════════════════════════════════════ */

  function animateCounter(element, start, end, duration, onUpdate) {
    var startTime = performance.now();
    var diff = end - start;

    function tick(now) {
      var elapsed = now - startTime;
      var progress = Math.min(elapsed / duration, 1);

      /* Ease out cubic */
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(start + diff * eased);

      element.textContent = formatNumber(current);

      if (onUpdate) onUpdate(current);

      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    }

    requestAnimationFrame(tick);
  }

  function formatNumber(n) {
    if (n >= 1000) {
      return n.toLocaleString('en-US');
    }
    return n.toString();
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* MAP CONTROLS                                                */
  /* ═══════════════════════════════════════════════════════════ */

  function initMap() {
    var mapSvg = $('#bh-map-wrap .bh-map-svg');
    if (!mapSvg) return;

    /* Hide all cities initially except Thorpe Abbotts */
    var cities = $$('.bh-map__city', mapSvg);
    cities.forEach(function(city) {
      if (!city.classList.contains('bh-map__city--thorpe')) {
        city.style.opacity = '0.3';
      }
    });

    /* Ensure all routes start hidden */
    var routes = $$('.bh-map__route', mapSvg);
    routes.forEach(function(route) {
      route.classList.remove('bh-map__route--active');
    });
  }

  function activateMap(active) {
    var mapSvg = $('#bh-map-wrap .bh-map-svg');
    if (!mapSvg) return;

    if (active) {
      mapSvg.classList.add('bh-map-svg--active');
    } else {
      mapSvg.classList.remove('bh-map-svg--active');
    }
  }

  function updateMapRoutes(chapterEl) {
    var mapWrap = document.getElementById('bh-map-wrap');
    if (!mapWrap) return;

    var routeStr = chapterEl.dataset.bhRoutes || '';
    var newRoutes = new Set(routeStr.split(',').filter(Boolean));

    /* Deactivate routes no longer needed */
    state.activeRoutes.forEach(function(routeId) {
      if (!newRoutes.has(routeId)) {
        var routeEl = $('#bh-route-' + routeId, mapWrap);
        if (routeEl) {
          routeEl.classList.remove('bh-map__route--active');
          var len = state.routeLengths.get('bh-route-' + routeId) || 1000;
          routeEl.style.strokeDashoffset = len;
        }
      }
    });

    /* Activate new routes with staggered timing, capped at a 3s total window */
    var routesToActivate = [];
    newRoutes.forEach(function(routeId) {
      if (!state.activeRoutes.has(routeId)) {
        var routeEl = $('#bh-route-' + routeId, mapWrap);
        if (routeEl) routesToActivate.push(routeEl);
      }
    });
    var MAX_STAGGER_MS = 3000;
    var increment = routesToActivate.length > 1
      ? Math.min(600, MAX_STAGGER_MS / (routesToActivate.length - 1))
      : 0;
    routesToActivate.forEach(function(routeEl, i) {
      trackedTimeout(function() {
        routeEl.classList.add('bh-map__route--active');
        routeEl.style.strokeDashoffset = '0';
      }, CONFIG.reducedMotion ? 0 : i * increment);
    });

    state.activeRoutes = newRoutes;
  }

  function updateCityHighlights(chapterEl) {
    var mapWrap = document.getElementById('bh-map-wrap');
    if (!mapWrap) return;

    var cityStr = chapterEl.dataset.bhCities || '';
    var newCities = new Set(cityStr.split(',').filter(Boolean));

    /* Reset all cities to dim */
    var allCities = $$('.bh-map__city', mapWrap);
    allCities.forEach(function(city) {
      city.classList.remove('bh-map__city--active');
      if (!city.classList.contains('bh-map__city--thorpe')) {
        city.style.opacity = '0.3';
        city.style.transition = 'opacity 0.5s ease';
      }
    });

    /* Activate target cities */
    newCities.forEach(function(cityName) {
      var cityEl = $('[data-city="' + cityName + '"]', mapWrap);
      if (cityEl) {
        cityEl.style.opacity = '1';
        if (cityName !== 'thorpe-abbotts' && cityName !== 'london') {
          cityEl.classList.add('bh-map__city--active');
        }
      }
    });

    /* Position target ring on the primary target (first non-home city) */
    var targetRing = $('#bh-target-ring', mapWrap);
    if (targetRing) {
      var targets = Array.from(newCities).filter(function(c) {
        return c !== 'thorpe-abbotts' && c !== 'london';
      });
      if (targets.length > 0 && CITY_COORDS[targets[0]]) {
        var coords = CITY_COORDS[targets[0]];
        targetRing.setAttribute('cx', coords.x);
        targetRing.setAttribute('cy', coords.y);
        targetRing.classList.add('bh-map__target-ring--active');
      } else {
        targetRing.classList.remove('bh-map__target-ring--active');
      }
    }

    state.activeCities = newCities;
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* LOSS ANIMATIONS                                             */
  /* ═══════════════════════════════════════════════════════════ */

  function triggerLossAnimations(chapterEl) {
    var lossRows = $$('.bh-loss-row[data-bh-loss]', chapterEl);

    lossRows.forEach(function(row) {
      var rowId = row.dataset.bhTotal + '-' + row.dataset.bhLoss;

      /* Don't re-trigger if already animated */
      if (state.lossAnimations.has(rowId)) return;
      state.lossAnimations.set(rowId, true);

      var total = parseInt(row.dataset.bhTotal, 10);
      var losses = parseInt(row.dataset.bhLoss, 10);
      var icons = $$('.bh-loss-icon', row);
      var startIndex = total - losses;

      if (CONFIG.reducedMotion) {
        /* Instant for reduced motion */
        for (var i = startIndex; i < total; i++) {
          if (icons[i]) {
            icons[i].classList.remove('bh-loss-icon--active');
            icons[i].classList.add('bh-loss-icon--lost');
          }
        }
        return;
      }

      /* Stagger the loss animations */
      for (var j = startIndex; j < total; j++) {
        (function(idx) {
          var d = (idx - startIndex) * CONFIG.lossStagger;
          trackedTimeout(function() {
            if (icons[idx]) {
              icons[idx].classList.remove('bh-loss-icon--active');
              icons[idx].classList.add('bh-loss-icon--lost');
            }
          }, d + 500);
        })(j);
      }
    });
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* FLAK BURST EFFECTS                                          */
  /* ═══════════════════════════════════════════════════════════ */

  function scheduleFlakBursts(chapterEl) {
    if (CONFIG.reducedMotion) return;

    var mapWrap = document.getElementById('bh-map-wrap');
    if (!mapWrap) return;

    var cityStr = chapterEl.dataset.bhCities || '';
    var targets = cityStr.split(',').filter(function(c) {
      return c !== 'thorpe-abbotts' && c !== 'london' && CITY_COORDS[c];
    });

    if (!targets.length) return;

    var flakEls = $$('.bh-map__flak', mapWrap);

    /* Fire a burst of flak near each target */
    targets.forEach(function(target, ti) {
      var coords = CITY_COORDS[target];
      if (!coords) return;

      for (var i = 0; i < Math.min(flakEls.length, 3); i++) {
        (function(flakIdx) {
          var d = ti * 800 + flakIdx * 200 + Math.random() * 400;
          trackedTimeout(function() {
            var flak = flakEls[flakIdx];
            if (!flak) return;

            var ox = coords.x + (Math.random() - 0.5) * 30;
            var oy = coords.y + (Math.random() - 0.5) * 20;

            flak.setAttribute('cx', ox);
            flak.setAttribute('cy', oy);
            flak.classList.remove('bh-map__flak--active');

            /* Force reflow to restart animation */
            void flak.offsetWidth;
            flak.classList.add('bh-map__flak--active');

            trackedTimeout(function() {
              flak.classList.remove('bh-map__flak--active');
            }, 900);
          }, d);
        })(i);
      }
    });
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* CHAPTER PROGRESS INDICATOR                                  */
  /* ═══════════════════════════════════════════════════════════ */

  function updateProgressIndicator(chapterId) {
    var progress = document.getElementById('bh-progress');
    if (!progress) return;

    /* Show progress bar once past hero */
    if (chapterId === 'hero') {
      progress.classList.remove('bh-progress--visible');
    } else {
      progress.classList.add('bh-progress--visible');
    }

    /* Update active dot */
    var dots = $$('.bh-progress__dot', progress);
    dots.forEach(function(dot) {
      dot.classList.remove('bh-progress__dot--active');
      if (dot.dataset.bhNav === chapterId) {
        dot.classList.add('bh-progress__dot--active');
      }
    });
  }

  function setupProgressNavigation() {
    var progress = document.getElementById('bh-progress');
    if (!progress) return;

    progress.addEventListener('click', function(e) {
      var dot = e.target.closest('.bh-progress__dot');
      if (!dot) return;
      e.preventDefault();

      var targetId = dot.getAttribute('href').substring(1);
      var target = document.getElementById(targetId);
      if (target) {
        target.scrollIntoView({
          behavior: CONFIG.reducedMotion ? 'auto' : 'smooth'
        });
      }
    });
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* INLINE COUNTER ANIMATIONS - TAC.observe with fallback       */
  /* ═══════════════════════════════════════════════════════════ */

  function setupInlineCounters(section) {
    var counters = $$('[data-bh-counter]', section);
    if (!counters.length) return null;

    if (window.TAC && TAC.observe) {
      var cleanups = [];
      counters.forEach(function(el) {
        var unsub = TAC.observe(el, function(entry) {
          if (entry.isIntersecting) {
            var target = parseInt(el.dataset.bhCounter, 10);
            if (isNaN(target) || el.dataset.bhCounted) return;
            el.dataset.bhCounted = 'true';

            if (CONFIG.reducedMotion) {
              el.textContent = formatNumber(target);
              return;
            }

            animateCounter(el, 0, target, CONFIG.counterDuration);
            unsub(); /* Stop observing after first trigger */
          }
        }, { threshold: 0.5 });
        cleanups.push(unsub);
      });
      return function() { cleanups.forEach(function(fn) { fn(); }); };
    }

    /* Fallback */
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.dataset.bhCounter, 10);

          if (isNaN(target) || el.dataset.bhCounted) return;
          el.dataset.bhCounted = 'true';

          if (CONFIG.reducedMotion) {
            el.textContent = formatNumber(target);
            return;
          }

          animateCounter(el, 0, target, CONFIG.counterDuration);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(c) { observer.observe(c); });
    return function() { observer.disconnect(); };
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* SCROLL PROGRESS TRACKER - TAC.onScroll with fallback        */
  /* ═══════════════════════════════════════════════════════════ */

  function setupScrollProgress() {
    var mapContainer = $('.bh-map-container');
    var mapSvg = $('#bh-map-wrap .bh-map-svg');
    if (!mapContainer || !mapSvg) return null;

    if (CONFIG.reducedMotion) return null;

    function onScrollTick() {
      var rect = mapContainer.getBoundingClientRect();
      var containerHeight = mapContainer.offsetHeight;
      var scrolled = -rect.top;
      var progress = Math.max(0, Math.min(1, scrolled / (containerHeight - window.innerHeight)));

      /* Subtle map zoom as user progresses through chapters */
      var scale = 1 + progress * 0.15;
      var translateY = progress * -5;

      /* Center the zoom on Thorpe Abbotts area */
      mapSvg.style.transformOrigin = '33% 42%';
      mapSvg.style.transform = 'scale(' + scale + ') translateY(' + translateY + '%)';
    }

    if (window.TAC && TAC.onScroll) {
      /* TAC.onScroll is already RAF-throttled */
      return TAC.onScroll('bh-scroll-progress', onScrollTick);
    }

    /* Fallback: manual RAF throttle */
    var ticking = false;
    function onScrollFallback() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        onScrollTick();
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScrollFallback, { passive: true });
    return function() { window.removeEventListener('scroll', onScrollFallback); };
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* CHAPTER BACKGROUND TINT (subtle atmosphere shifts)          */
  /* ═══════════════════════════════════════════════════════════ */

  function setupChapterAtmosphere(section) {
    var chapters = $$('[data-bh-chapter]', section);
    var bgTints = {
      'hero': 'transparent',
      '1':    'rgba(10, 11, 14, 0.85)',
      '2':    'rgba(10, 11, 14, 0.85)',
      '3':    'rgba(10, 11, 14, 0.88)',
      '4':    'rgba(15, 10, 10, 0.90)',
      '5':    'rgba(20, 10, 10, 0.92)',
      '6':    'rgba(10, 11, 14, 0.88)',
      '7':    'rgba(10, 11, 14, 0.88)',
      '8':    'rgba(10, 11, 14, 0.85)',
      '9':    'rgba(10, 11, 14, 0.80)'
    };

    chapters.forEach(function(ch) {
      var id = ch.dataset.bhChapter;
      if (bgTints[id]) {
        ch.style.backgroundColor = bgTints[id];
      }
    });
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* ALL-ROUTES REVEAL (Chapter IX - final visual)               */
  /* ═══════════════════════════════════════════════════════════ */

  function setupFinalReveal(section) {
    var ch9 = document.getElementById('bh-ch-9');
    if (!ch9) return null;

    var revealed = false;

    function onFinalVisible(entry) {
      if (revealed) return;
      if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
        revealed = true;
        revealAllRoutes();
      }
    }

    if (window.TAC && TAC.observe) {
      return TAC.observe(ch9, onFinalVisible, { threshold: 0.3 });
    }

    /* Fallback */
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
          revealAllRoutes();
          observer.unobserve(ch9);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(ch9);
    return function() { observer.disconnect(); };
  }

  function revealAllRoutes() {
    var mapWrap = document.getElementById('bh-map-wrap');
    if (!mapWrap) return;

    var routes = $$('.bh-map__route', mapWrap);
    var allCities = $$('.bh-map__city', mapWrap);

    /* Show all cities */
    allCities.forEach(function(city) {
      city.style.opacity = '0.7';
      city.style.transition = 'opacity 1s ease';
    });

    /* Draw all routes with stagger */
    routes.forEach(function(route, i) {
      var delay = CONFIG.reducedMotion ? 0 : i * 300;
      trackedTimeout(function() {
        route.classList.add('bh-map__route--active');
        route.style.strokeDashoffset = '0';
        route.style.opacity = '0.5';
      }, delay);
    });

    /* After all routes drawn, fade them */
    if (!CONFIG.reducedMotion) {
      var totalDelay = routes.length * 300 + 2000;
      trackedTimeout(function() {
        routes.forEach(function(route, i) {
          trackedTimeout(function() {
            route.style.transition = 'opacity 2s ease';
            route.style.opacity = '0.15';
          }, i * 100);
        });
      }, totalDelay);
    }
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* KEYBOARD / ACCESSIBILITY                                    */
  /* ═══════════════════════════════════════════════════════════ */

  function setupAccessibility(section) {
    function keydownHandler(e) {
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;

      var chapters = $$('[data-bh-chapter]', section);
      var chaptersArr = Array.from(chapters);
      var currentIdx = chaptersArr.findIndex(function(ch) {
        return ch.dataset.bhChapter === state.currentChapter;
      });

      var targetIdx = -1;

      if (e.key === 'ArrowDown' || e.key === 'PageDown') {
        targetIdx = Math.min(currentIdx + 1, chaptersArr.length - 1);
      } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
        targetIdx = Math.max(currentIdx - 1, 0);
      }

      if (targetIdx >= 0 && targetIdx !== currentIdx) {
        e.preventDefault();
        chaptersArr[targetIdx].scrollIntoView({ behavior: CONFIG.reducedMotion ? 'auto' : 'smooth' });
      }
    }

    document.addEventListener('keydown', keydownHandler);
    return function() { document.removeEventListener('keydown', keydownHandler); };
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* REDUCED MOTION - TAC.prefersReducedMotion with fallback     */
  /* ═══════════════════════════════════════════════════════════ */

  function initReducedMotion() {
    if (window.TAC && TAC.prefersReducedMotion) {
      CONFIG.reducedMotion = TAC.prefersReducedMotion();
    } else {
      CONFIG.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    mq.addEventListener('change', function(e) {
      CONFIG.reducedMotion = e.matches;
    });
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* TAC FALLBACK: .tac-reveal basic observer for non-TAC envs   */
  /* ═══════════════════════════════════════════════════════════ */

  function setupTacRevealFallback(section) {
    if (window.TAC) return null; /* TAC handles .tac-reveal natively */

    var els = $$('.tac-reveal', section);
    if (!els.length) return null;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    els.forEach(function(el) { observer.observe(el); });
    return function() { observer.disconnect(); };
  }


  /* ═══════════════════════════════════════════════════════════ */
  /* REGISTRATION & BOOT                                         */
  /* ═══════════════════════════════════════════════════════════ */

  if (window.TAC && TAC.registerSection) {
    TAC.registerSection('bloody-hundredth', {
      init: function(el) {
        initReducedMotion();
        measureRoutes();
        buildLossRows();
        initMap();
        setupChapterAtmosphere(el);
        setupProgressNavigation();

        /* Collect cleanup functions */
        var cleanups = [
          setupRevealObserver(el),
          setupChapterObserver(el),
          setupInlineCounters(el),
          setupScrollProgress(),
          setupFinalReveal(el),
          setupAccessibility(el),
          setupTacRevealFallback(el)
        ].filter(Boolean);

        return cleanups;
      },

      destroy: function(el) {
        clearPendingTimeouts();
        state.initialized = false;
        state.currentChapter = null;
        state.lossAnimations.clear();
        state.activeRoutes.clear();
        state.activeCities.clear();
        state.tallyValues = { missions: 0, sorties: 0, aircraft: 0, kia: 0, pow: 0 };
        state.tallyVisible = false;
      }
    });
  } else {
    /* ─── FALLBACK BOOT (no TAC available) ─── */

    var _cleanups = [];

    function boot() {
      var section = document.querySelector('.bh');
      if (!section || state.initialized) return;

      initReducedMotion();
      measureRoutes();
      buildLossRows();
      initMap();
      setupChapterAtmosphere(section);
      setupProgressNavigation();

      _cleanups = [
        setupRevealObserver(section),
        setupChapterObserver(section),
        setupInlineCounters(section),
        setupScrollProgress(),
        setupFinalReveal(section),
        setupAccessibility(section),
        setupTacRevealFallback(section)
      ].filter(Boolean);

      state.initialized = true;
    }

    function cleanup() {
      clearPendingTimeouts();
      _cleanups.forEach(function(fn) { fn(); });
      _cleanups = [];
      state.initialized = false;
      state.currentChapter = null;
      state.lossAnimations.clear();
      state.activeRoutes.clear();
      state.activeCities.clear();
      state.tallyValues = { missions: 0, sorties: 0, aircraft: 0, kia: 0, pow: 0 };
      state.tallyVisible = false;
    }

    /* Run on DOM ready */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    /* Also run after Shopify section load (theme editor) */
    document.addEventListener('shopify:section:load', function(e) {
      if (e.target.querySelector('.bh')) {
        cleanup();
        boot();
      }
    });
  }

})();
